import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JeevesDeliveryLocation } from '../../models/jeevesDeliveryLocation';
import { GungStringConverterService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class DeliveryLocationsService {
  constructor(protected http: HttpClient) {}

  getDeliveryLocationsForCustomer(customerId: string): Observable<JeevesDeliveryLocation[]> {
    const headers = {
      maxAge: '-1'
    };
    const url = `json/customer/${GungStringConverterService.toGungString(customerId)}/delivery-locations`;
    return this.http.get<JeevesDeliveryLocation[]>(url, { headers: headers });
  }

  createNewCustomerDeliveryLocation(deliveryLocation: JeevesDeliveryLocation): Observable<JeevesDeliveryLocation> {
    const url = `json/customer/${GungStringConverterService.toGungString(deliveryLocation.customerId)}/delivery-locations`;
    return this.http.post<JeevesDeliveryLocation>(url, deliveryLocation);
  }
}
